/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import PhoneInput from './phone-input';
import parsePhoneNumber from 'libphonenumber-js';
import './phone-input/styles/bootstrap.css';

import * as S from '../../styles';

export interface IPhoneNumberInputProps {
  id: string;
  label?: string;
  value?: string;
  errorText?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  labelColor?: string;
  hasError?: boolean;
  onCompChange?(id: string, payload: any): void;
}

export const PhoneNumberInput = ({
  id,
  label,
  hasError,
  errorText,
  value,
  required,
  placeholder,
  onCompChange,
  labelColor,
}: IPhoneNumberInputProps) => {
  const [valid, setValid] = useState<Boolean>(true);
  const [textValue, setTextValue] = useState(value ?? '');
  const [errorData, setErrorData] = useState('');
  const onChange = (id: string, e: any, country, formattedNumber) => {
    const number = `+${e}`;
    setTextValue(number);
    const phoneValid = parsePhoneNumber(number);
    if (phoneValid?.isValid()) {
      if (!valid) {
        setValid(true);
      }
      onCompChange && onCompChange(id, number);
    } else {
      if (valid) {
        setValid(false);
      }
    }
  };
  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (hasError && errorText) {
      return (
        <S.FeedbackOtherLabel type="tooltip">{errorText}</S.FeedbackOtherLabel>
      );
    }
    if (!valid) {
      return (
        <S.FeedbackOtherLabel type="tooltip">
          {/* {'Phone number is not valid!'} */}
          {`Phone number should contain atleast ${errorData} numbers`}
        </S.FeedbackOtherLabel>
      );
    }
    return null;
  };

  return (
    <>
      <Form.Group id={id} className="mb-4 formgroup">
        {_renderLabelIf()}
        <InputGroup>
          <PhoneInput
            className="formcontrol shadow-none"
            onChange={onChange.bind(null, id)}
            required={required}
            value={textValue}
            placeholder={placeholder}
            enableSearch={true}
            // disableCountryCode={true}
            // disabled={true}
            copyNumbersOnly={false}
            setErrorData={setErrorData}
          />
          <InputGroup>{_renderErrorTextIf()}</InputGroup>
        </InputGroup>
      </Form.Group>
    </>
  );
};

PhoneNumberInput.defaultProps = {
  required: false,
  hasError: false,
};
